module.exports = __webpack_public_path__ + "static/media/vector3.fe1e057e.svg";